import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconAncap: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="ancap">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3a9 9 0 1 1-6.34 15.388l-.024-.024-.024-.024A9 9 0 0 1 12 3Zm-7.777 8.4A7.802 7.802 0 0 1 11.4 4.223V11.4H4.223Zm15.554 1.2H12.6v7.177a7.802 7.802 0 0 0 7.177-7.177Z"
    />
  </Icon>
);
